import { render, staticRenderFns } from "./DisclosureInformationFS.vue?vue&type=template&id=254c6956&scoped=true"
import script from "./DisclosureInformationFS.vue?vue&type=script&lang=ts"
export * from "./DisclosureInformationFS.vue?vue&type=script&lang=ts"
import style0 from "./DisclosureInformationFS.vue?vue&type=style&index=0&id=254c6956&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c6956",
  null
  
)

export default component.exports